import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import Pagination from "react-js-pagination";
import moment from 'moment';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import { Multiselect } from 'multiselect-react-dropdown';
import './../../multiselect.css';
class LeavesByEmployee extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            leaves: [],
            leave_detail: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            search: [],
            loading: 1,
            activePage: 1,
            user: [],
            owners: [],
            fields: {},
            item_count: '',
            isLoadMore: 1,
        };
        this.getEmployees = this.getEmployees.bind(this);
        this.getAllUsers = this.getAllUsers.bind(this);
        this.searchEmployee = this.searchEmployee.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    searchEmployee(selectedList, selectedItem) {
        var srchempid = [];
        selectedList.forEach(function (item) {
            srchempid.push(item.id);
        });
        this.setState({ search: srchempid });
        this.getEmployees(1, srchempid);
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/HrmanagementRest/getEmployees/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        users: findresponse.users,
                        quarter: findresponse.quarter,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }

    }

    getEmployees(page = 1, srchemployee) {
        $(document).ready(function () {
            $('.loader-new').removeClass('hidden');
        });
        this.state.search = srchemployee;
        fetch(this.state.apiUrl + '/HrmanagementRest/getEmployees/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                $(document).ready(function () {
                    $('.loader-new').addClass('hidden');
                });
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    users: findresponse.users,
                    quarter: findresponse.quarter,
                    loading: 0,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    item_count: findresponse.item_count,
                    setPage: 'yes',
                    hr_permission: findresponse.hr_permission
                });
            });
    }
    getAllUsers() {
        fetch(this.state.apiUrl + '/HrmanagementRest/getAllUsers/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    owners: findresponse,
                });
            });
    }
    //    componentDidMount() {
    async componentWillMount() {
        document.title = "Intranet | Leave Balances";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getEmployees();
        this.getAllUsers();
    }

    getUserRows() {
        if (this.state.loading) {
            return <div class="loader-new"></div>;
        } else {
            return (
                <div>
                    <div class="body-content">
                        <div class="employee-list table-wrap">
                            <table>
                                <thead>
                                    <th class="intra_col_50" id="col_name">
                                        Employee Name
                                    </th>
                                    <th class="intra_col_25" id="col_name">
                                        Total Leaves (Yearly)
                                    </th>
                                    <th class="intra_col_25" id="col_available_leaves">
                                        Leave Balance for {this.state.quarter}
                                    </th>
                                    {/*<li class="intra_col_20" id="col_leaves_taken">Leaves Taken</li>*/}
                                </thead>
                                <tbody>
                                    {this.state.users.map((user, key) => (
                                        <tr>
                                            <td class="intra_col_50">
                                                <Link
                                                    key={key}
                                                    to={`/viewEmployee/${user.id}`}
                                                    name={"max"}
                                                >
                                                    {user.name}
                                                </Link>
                                            </td>
                                            <td class="intra_col_25">{user.total_leave}</td>
                                            <td class="intra_col_25">{user.available_leave}</td>
                                            {/*<li class="intra_col_20">{user.leaves_taken}</li>*/}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {this.state.item_count > 0 ? (
                                <div
                                    class="d-flex mu-pagination justify-content-between align-items-center"
                                    aria-label="Page navigation example"
                                >
                                    <div class="txt-dark">
                                        Showing {this.state.offset + 1}~
                                        {this.state.offset + this.state.off_count} of{" "}
                                        {this.state.item_count}
                                    </div>
                                    <div class="mu-pagination">
                                        <Pagination
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={20}
                                            totalItemsCount={this.state.item_count}
                                            pageRangeDisplayed={5}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            onChange={
                                                this.state.setPage == "yes" ? this.handlePageChange : ""
                                            }
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="text-center"
                                    style={{
                                        color: "#333",
                                        fontSize: "16px",
                                        padding: "70px",
                                        fontWeight: "500",
                                    }}
                                >
                                    No Data Found
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        if (this.state.hr_permission == 'no') {
            return (
                <Redirect to={'/home'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Leave Balances" brecum_page="Leave Balances" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Leave Balances</span>
                        </div>
                        <div class="top-row">
                            <div class="left-section leavelop btn-muvi pull-left">
                                <a href="/leaves" class="btn btn-blue mob">
                                    Back
                                </a>
                            </div>
                            <div class="right-section leavelop pull-right">
                                <div className="col-md-10">
                                    Employees:
                                    <Multiselect
                                        options={this.state.owners}
                                        selectedValues={this.state.user}
                                        style={{ paddingLeft: '0px', marginTop: '10px' }}
                                        onSelect={this.searchEmployee}
                                        onRemove={this.searchEmployee}
                                        displayValue="name"
                                        placeholder="Type & Select"
                                    />
                                </div>
                            </div>
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        )
    }
}
export default LeavesByEmployee;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/leavesByEmployee.js